export default "__VITE_ASSET__C20qzj3P__"